module.exports = __webpack_public_path__ + "static/media/who-17.a1db422c.jpg";